export default __webpack_public_path__ + "static/media/avatar_arrow_boy2.7b6ede61.mp3";